import { removeFalsey as d } from "./index.esm3.js";
import { formatNumber as y } from "./index.esm8.js";
const a = {
  EUR: {
    symbolPosition: "after",
    symbol: "€",
    decimalPlaces: 2,
    integer: !1,
    includeSymbol: !0,
    showPositiveSign: !1
  }
}, c = {
  amount: 0,
  currency: "EUR"
}, s = (r, t) => {
  if (!r && (t == null ? void 0 : t.fallback) !== void 0)
    return t == null ? void 0 : t.fallback;
  const e = r ?? c, n = {
    ...a[e.currency] ?? a.EUR,
    ...t
  }, o = !n.showAbsoluteZeroDecimalPlaces && e.amount === 0 || n.integer && e.amount % 100 === 0 ? 0 : n.decimalPlaces, f = y(e.amount / 100, {
    decimalPlaces: o
  }), i = n.showPositiveSign && e.amount >= 0 ? "+" : "", l = n.includeSymbol ? n.symbol : "", m = n.symbolPosition === "before" ? l : "", b = n.symbolPosition === "after" ? l : "";
  return `${m}${i}${f}${b}`;
}, g = (r, t) => s(r, {
  ...t,
  fallback: (t == null ? void 0 : t.fallback) ?? ""
}), h = (r) => {
  var e;
  const t = r.filter((u) => !!u);
  return t.length === 0 ? c : {
    amount: r.filter(d).map((u) => u.amount ?? 0).reduce((u, n) => u + n, 0),
    currency: ((e = t[0]) == null ? void 0 : e.currency) ?? c.currency
  };
}, S = ({ amount: r, currency: t }, e) => e <= 0 ? c : {
  amount: Math.floor(r / e),
  currency: t
}, M = ({ amount: r, currency: t }, e) => e <= 0 ? c : {
  amount: Math.floor(r * e),
  currency: t
}, P = (r, t) => {
  const [e, u] = r.replace(".", ",").split(","), n = `${(u == null ? void 0 : u.slice(0, 2)) ?? ""}${Array.from({
    length: 2 - ((u == null ? void 0 : u.length) ?? 0)
  }).map(() => "0").join("")}`;
  return {
    amount: Number.parseInt(`${e}${n}`),
    currency: t
  };
}, $ = (r, t = "") => {
  var e;
  return ((e = a[r]) == null ? void 0 : e.symbol) ?? t;
}, v = ({ amount: r }) => r / 100, k = (r, t) => ({
  amount: ((r == null ? void 0 : r.amount) ?? 0) - ((t == null ? void 0 : t.amount) ?? 0),
  currency: (r == null ? void 0 : r.currency) ?? c.currency
}), E = (r, t) => r ? t ? r.amount > t.amount : !0 : !1, U = (r, t) => r ? t ? r.amount >= t.amount : !0 : !1, w = (r) => ({
  amount: Math.abs(r.amount),
  currency: r.currency ?? c.currency
}), O = (r) => ({
  amount: Math.floor(r.amount / 100) * 100,
  currency: r.currency
}), A = {
  defaultMoney: c,
  formatMoney: g,
  moneyToString: s,
  sum: h,
  divide: S,
  multiply: M,
  subtract: k,
  parseString: P,
  getCurrencySymbol: $,
  moneyToFloat: v,
  isGreater: E,
  isGreaterOrEqual: U,
  absolute: w,
  floor: O
};
export {
  A as MoneyUtils,
  w as absolute,
  c as defaultMoney,
  S as divide,
  O as floor,
  g as formatMoney,
  $ as getCurrencySymbol,
  E as isGreater,
  U as isGreaterOrEqual,
  v as moneyToFloat,
  s as moneyToString,
  M as multiply,
  P as parseString,
  k as subtract,
  h as sum
};
